import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import React, { useState } from "react";
import { View, Text, StyleSheet } from "react-native";
import { useTheme } from "styled-components/native";
import ReactDOM from "react-dom";
import { TooltipTextProps } from "./types";
import { productLevelOneColor } from "@utils/product/productTheme";
import { ProductCategory } from "@utils/constants";

const TOOLTIP_WIDTH = 280;
const VIEWPORT_MARGIN = 12;

const TooltipImage = ({
  tooltip,
  enableTooltip,
  productType,
}: TooltipTextProps) => {
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({
    top: 0,
    left: 0,
    arrowOffset: 0,
  });

  const handleMouseEnter = (event) => {
    const target = event.currentTarget ?? event.target;
    const rect = target.getBoundingClientRect();
    const iconCenter = rect.left + rect.width / 2;
    const maxLeft = window.innerWidth - VIEWPORT_MARGIN - TOOLTIP_WIDTH;
    const left = Math.min(
      Math.max(iconCenter - TOOLTIP_WIDTH / 2, VIEWPORT_MARGIN),
      Math.max(VIEWPORT_MARGIN, maxLeft)
    );

    setTooltipPosition({
      top: rect.bottom + window.scrollY + 8,
      left: left + window.scrollX,
      arrowOffset: iconCenter - (left + TOOLTIP_WIDTH / 2),
    });
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <View
      style={styles.container}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Replace this with actual image/icon component if needed */}
      <VDBIcon
        color={theme[productLevelOneColor(productType as ProductCategory)]}
        size={SpaceType.LargeDouble}
        variant={IconsVariant.VDBCustom}
        name={VDBIcons.PRICE_COMMENT}
      />

      {isHovered &&
        enableTooltip &&
        ReactDOM.createPortal(
          <View
            style={[
              styles.tooltipContainer,
              {
                position: "absolute",
                top: tooltipPosition.top,
                left: tooltipPosition.left,
              },
            ]}
          >
            <View
              style={[
                styles.arrow,
                { transform: [{ translateX: tooltipPosition.arrowOffset }] },
              ]}
            />
            <View style={styles.tooltip}>
              <Text style={styles.tooltipText}>{tooltip}</Text>
            </View>
          </View>,
          document.body
        )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    cursor: "pointer",
  },
  tooltip: {
    backgroundColor: "black",
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 4,
    zIndex: 10,
    width: TOOLTIP_WIDTH,
  },
  tooltipContainer: {
    alignItems: "center",
    zIndex: 1000,
  },
  tooltipText: {
    fontSize: 12,
    lineHeight: 16,
    color: "#fff",
  },
  arrow: {
    width: 0,
    height: 0,
    top: -5,
    borderLeftWidth: 6,
    borderRightWidth: 6,
    borderBottomWidth: 6,
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderBottomColor: "black",
    marginBottom: -1,
  },
});

export default TooltipImage;
